export const getReproductiveStatusOptions = (t) => [
	{ value: 'criando', label: t('admin.animal.reproductive_status_criando') },
	{ value: 'seca', label: t('admin.animal.reproductive_status_seca') },
	{ value: 'desvieje', label: t('admin.animal.reproductive_status_desvieje') }
]